module.exports = __webpack_public_path__ + "assets/media/empty-state.d5fa9d69.svg";